import { forwardRef } from 'react';
import type { ComponentRef } from 'react';

import { View as RNView } from 'react-native';
import type { ViewProps } from 'react-native';

type BoxRef = ComponentRef<typeof RNView>;
export type BoxProps = ViewProps;

export const Box = forwardRef<BoxRef, BoxProps>((props, ref) => <RNView ref={ref} {...props} />);

Box.displayName = 'Box';
